import type { FaireProductEntity } from "../../entity_types/product";

export const p_cmr6c6w6je: FaireProductEntity = {
  token: "p_cmr6c6w6je",
  type: "product",
  name: "Frose' Frozen Cocktail -Just add Water + Wine",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/d465392d81bcfb2947e5a0f7c9e29364f81fee785a5836e338aa48c30f149bf7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f15fa522f4c9a64fc93b0dd567e70d93a91f4fea737cd47324b781fab08d84d1.png",
    "https://cdn.faire.com/fastly/ca3db623df566c9f24251be1c20072f1e010e2d0c85edc15cdf342598844871e.png",
    "https://cdn.faire.com/fastly/b62e2c37ccbc7991d45f674ebf7b8f47a627923f08d1fa2f0b13af4ed6f61aab.png",
  ],
  priceDollars: 8.5,
  description:
    "Frozen Cocktails don't get easier than this! Each bag makes 8 servings. No blenders ever! Simply add 1 bottle of Rose' and 1 bottle of water, shake or stir and throw in the freezer. \n\nOur Frozen cocktails are unique in you ONLY ever add water and spirit...NEVER any juice, mixers or additional flavors. That's one of the things that sets us apart. 100% all natural ingredients and perfect to share with friends and family at your next party. Cheers from Noble Mick's\n\n- 100% All-Natural Ingredients\n- Easy Prep:  Mix, Freeze & Serve Directly in the Bag \n- No Artificial Flavors or Colors\n- Made in the USA 🇺🇸\n- Vegan & Gluten-Free \n- Makes 8 Servings per Bag\n- No Blender Needed\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Bold color and design makes merchandising a breeze!",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:02.576Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
